module.exports = __webpack_public_path__ + "img/1500985547.af40bb33.jpg";